import * as React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { colors } from "../../../../utils";

const StyledTextField = styled(TextField)(({ theme }) => ({
  height: 40,
  width: "100%",
  marginLeft: "5px",
  backgroundColor: colors.white,
  "& .MuiInputBase-input": {
    color: "#212529 !important"
  },
  "& .MuiInputBase-root": {
    height: "100%",
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "DM Sans, sans-serif",
    color: "#212529"
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
      borderRadius: 5,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    // ISP-9999 (fix-kelly-discount-code-purple-focus-glow): this used to
    // ALSO repaint the fieldset purple on `&.Mui-focused` — a second,
    // bigger purple box around the inner `<input>`, which already gets its
    // own ring directly from the app-wide focus sheet
    // (src/styles/focusRing.css beats this component's local
    // `outline: none` on specificity). Pinned to the resting (transparent)
    // border so the one ring painted on the input stays the ONLY focus
    // indicator — same fix already applied to SearchField.jsx (#4888),
    // MediaLibrary's SearchBox (#4879) and CreateFolder's fields (#5081).
    //
    // Targets the CLASS `.MuiOutlinedInput-notchedOutline`, not the bare
    // `fieldset` type selector, ON PURPOSE: MUI ships its own built-in
    // `.<hash>.Mui-focused .MuiOutlinedInput-notchedOutline` rule painting
    // the theme's primary purple on this exact node, and a same-specificity
    // (or lower) override loses to it — measured live via a real mount +
    // real focus event (muiSearchFieldFocusGlow.test.jsx): a `fieldset`
    // type-selector version of this override STILL LOST to MUI's own rule
    // (tied class-count specificity, MUI's rule injected later). One more
    // class-level selector clears that tie unambiguously, the same shape
    // already proven live for SearchField.jsx. See
    // src/theme/focusRingHardcodeRatchet.test.js for the app-wide guard.
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
  },
}));

export default function MuiSearchField({
  placeholder = "",
  showIcon = true,
  iconPosition = "start",
  value = "",
  handleChange = () => {},
  sx = {},
  ...rest
}) {
  return (
    <StyledTextField
      placeholder={placeholder}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      sx={sx}
      InputProps={{
        startAdornment: showIcon ? (
          <InputAdornment position={iconPosition}>
            <SearchIcon />
          </InputAdornment>
        ) : null,
      }}
      {...rest}
    />
  );
}
